var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaret(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.768581 0C0.623512 2.91342e-05 0.481413 0.0387021 0.358704 0.11155C0.235995 0.184398 0.137684 0.288447 0.0751334 0.411674C0.0125825 0.534901 -0.0116559 0.672276 0.00521935 0.807924C0.0220946 0.943572 0.0793945 1.07196 0.170498 1.17824L3.10249 4.59644C3.21058 4.72245 3.34725 4.8241 3.50248 4.89393C3.65771 4.96376 3.82757 5 3.99962 5C4.17166 5 4.34152 4.96376 4.49675 4.89393C4.65198 4.8241 4.78865 4.72245 4.89674 4.59644L7.8295 1.17824C7.92061 1.07196 7.97791 0.943572 7.99478 0.807924C8.01166 0.672276 7.98742 0.534901 7.92487 0.411674C7.86232 0.288447 7.76401 0.184398 7.6413 0.11155C7.51859 0.0387021 7.37649 2.91342e-05 7.23142 0H0.768581Z",
    fill: "#078950"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaret);
export default __webpack_public_path__ + "static/media/caret.2e59e9e8.svg";
export { ForwardRef as ReactComponent };